<template>
  <p class="tw:px-2 tw:mb-0 tw:text-muted-foreground tw:text-sm tw:italic">
    <slot />
  </p>
</template>

<script setup>
</script>
